import markdownIt from "markdown-it";
import DOMPurify from "dompurify";

let hooksRegistered = false;

export function ensureStyleHook() {
  if (hooksRegistered) return;
  hooksRegistered = true;
  DOMPurify.addHook("afterSanitizeAttributes", node => {
    if (node.hasAttribute("style")) {
      const style = node.getAttribute("style") || "";
      const allowed = style.match(/(background-color|color)\s*:\s*[^;]+/gi);
      if (allowed) {
        node.setAttribute("style", allowed.join("; "));
      } else {
        node.removeAttribute("style");
      }
    }
  });
}

const useMarkdownIt = ({ content: rawContent }: { content: string | undefined }) => {
  const md = markdownIt({ html: true });
  const initialHtml = md.render(rawContent || "");
  ensureStyleHook();
  const content = DOMPurify.sanitize(initialHtml, { ADD_ATTR: ["style"] });

  return { content };
};

export default useMarkdownIt;
